import React from "react";
import SparkBar from "../SparkBar/SparkBar";
import { formatNumber } from "../../../utils/numberFormat";
import {
  CompactRowContainer,
  CompactRowLabel,
  CompactRowIcon,
  CompactRowLabelText,
  CompactFYSection,
  CompactFYHeader,
  CompactFYLabel,
  CompactFYValue,
  CompactFYUnit,
} from "./Card.styled";

/**
 * Side-by-side "Current FY vs Previous FY" comparison row.
 * Used for emission, energy, NOx, SOx, PPM, or any metric comparison.
 *
 * @param {string} icon         — emoji icon
 * @param {string} label        — row label
 * @param {number} currentVal   — current period value
 * @param {number} previousVal  — previous period value
 * @param {string} unit         — unit label
 * @param {string} accentColor  — accent color for label and current value
 * @param {string} bgColor      — container background
 * @param {string} borderColor  — container border color
 */
const CompactComparisonRow = ({
  icon,
  label,
  currentVal,
  previousVal,
  unit,
  accentColor,
  bgColor,
  borderColor,
}) => {
  const cur = Number(currentVal) || 0;
  const prev = Number(previousVal) || 0;
  const max = Math.max(cur, prev, 1);

  return (
    <CompactRowContainer $bgColor={bgColor} $borderColor={borderColor}>
      {/* Label badge */}
      <CompactRowLabel $borderColor={borderColor}>
        <CompactRowIcon>{icon}</CompactRowIcon>
        <CompactRowLabelText $accentColor={accentColor}>
          {label}
        </CompactRowLabelText>
      </CompactRowLabel>

      {/* Current FY */}
      <CompactFYSection $borderRight={borderColor}>
        <CompactFYHeader>
          <CompactFYLabel>Current FY</CompactFYLabel>
          <CompactFYValue $color={accentColor}>
            {formatNumber(cur)}{" "}
            <CompactFYUnit>{unit}</CompactFYUnit>
          </CompactFYValue>
        </CompactFYHeader>
        <SparkBar value={cur} max={max} color={accentColor} />
      </CompactFYSection>

      {/* Previous FY */}
      <CompactFYSection>
        <CompactFYHeader>
          <CompactFYLabel>Previous FY</CompactFYLabel>
          <CompactFYValue $color="var(--ink-3)">
            {formatNumber(prev)}{" "}
            <CompactFYUnit>{unit}</CompactFYUnit>
          </CompactFYValue>
        </CompactFYHeader>
        <SparkBar value={prev} max={max} color="var(--ink-4)" />
      </CompactFYSection>
    </CompactRowContainer>
  );
};

export default CompactComparisonRow;
